<template>
    <div id="print-preview">
        <div id="printContent" class="print-zone" v-loading="loading">
            <div v-bind:key="item.EntpCusOId" v-for="item in printList">
                <div class="print-title">
                    <div>STATEMENT MARKETING EXPENSES FROM</div>
                    <div>{{ company }}</div>
                </div>
                <div class="order-detail">
                    <div>NO. {{ item.OrderCode }}</div>
                    <div>
                        DATE：
                        <el-date-picker
                            v-show="isEditOpenTime"
                            v-model="item.CreateTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            size="small"
                            placeholder="选择日期时间"
                        ></el-date-picker>
                        <span v-show="!isEditOpenTime">{{ item.CreateTime }}</span>
                    </div>
                </div>
                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">CLIENT</div>
                        <div class="div-table-cell" style="width: 80%">
                            <div class="cell-content">{{ item.EntpCusName }}</div>
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">ADDRESS</div>
                        <div class="div-table-cell" style="width: 80%">
                            <div class="cell-content">{{ item.FullAddress }}</div>
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 6%">NO.</div>
                        <div class="div-table-cell" style="width: 20%">PART NO.</div>
                        <div class="div-table-cell" style="width: 20%">DESCRIPTION</div>
                        <div class="div-table-cell" style="width: 20%">MODEL</div>
                        <div class="div-table-cell" style="width: 6%">QTY</div>
                        <div class="div-table-cell" style="width: 6%">UNIT</div>
                        <div class="div-table-cell" style="width: 13%">UNIT PRICE</div>
                        <div class="div-table-cell" style="width: 13%">SUM TOTAL</div>
                    </div>
                    <div class="div-table-row" v-bind:key="index" v-for="(AP, index) in item.DetailList">
                        <div class="div-table-cell" style="width: 6%">
                            {{ AP.SortNum == 0 ? Number(index) + 1 : AP.SortNum }}
                        </div>
                        <div class="div-table-cell img-content" style="width: 20%">
                            <div v-if="AP.GoodImg">
                                <img class="goodimg" :src="AP.GoodImg" />
                            </div>
                            <div>{{ AP.APCode }}</div>
                        </div>
                        <div class="div-table-cell" style="width: 20%">
                            {{ AP.GoodName }}
                        </div>
                        <div class="div-table-cell" style="width: 20%">
                            {{ AP.AutoSerise }}
                        </div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.Count }}</div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.Unit }}</div>
                        <div class="div-table-cell" style="width: 13%">{{ AP.Price }}</div>
                        <div class="div-table-cell" style="width: 13%">
                            {{ (AP.Count * AP.Price).toFixed(2) }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 6%"></div>
                        <div class="div-table-cell" style="width: 20%"></div>
                        <div class="div-table-cell" style="width: 20%"></div>
                        <div class="div-table-cell" style="width: 20%">TOTAL QUANTITY &nbsp;</div>
                        <div class="div-table-cell" style="width: 6%">{{ allNum }}</div>
                        <div class="div-table-cell" style="width: 6%"></div>
                        <div class="div-table-cell" style="width: 13%">TOTAL &nbsp;</div>
                        <div class="div-table-cell" style="width: 13%">
                            {{ (allPrice + item.ShipAmount).toFixed(2) }}
                        </div>
                    </div>
                </div>
                <div class="order-detail">
                    <div>PAYMENT：{{ item.PayTypeName }}</div>
                    <div>DELIVER WAY：{{ item.ShipTypeName }}</div>
                    <div>SHIPPING COST：{{ item.ShipAmount }}</div>
                    <div>SALES：{{ nameConfig ? (item.SNickName ? item.SNickName : item.SName) : item.SName }}</div>
                </div>
                <div class="order-remark" v-if="item.DiscountAmount">
                    <div>DISCOUNT AMOUNT：{{ item.DiscountAmount }}</div>
                    <div>TOTAL AMOUNT：{{ allPrice - item.DiscountAmount }}</div>
                </div>
                <div class="order-remark" v-if="item.Remark">
                    <div>CUSTOMER DEMAND：{{ item.Remark }}</div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <!--   开单时间   -->
                <div class="open-time">
                    <el-button class="btn-primary" size="small" @click="setOpenTime()" v-if="openTimeConfig && openTimeConfig.Result && !isEditOpenTime"
                        >设置开单时间</el-button
                    >
                    <el-button class="btn-primary" size="small" @click="submitOpenTime()" v-if="isEditOpenTime">保存开单时间</el-button>
                </div>
            </div>
            <div v-if="printType == 1" class="re-submit">
                <el-button class="btn-primary" size="small" v-print="'#printContent'" ref="returnOrderList" @click="returnOrderList(true)">打印并返回列表</el-button>
                <el-button class="btn-primary" size="small" v-print="'#printContent'" @click="continueToOrder()">打印并继续开单</el-button>
                <el-button size="small" @click="returnOrderList(false)">返回列表</el-button>
            </div>
            <div v-else class="re-submit">
                <el-button class="btn-primary" size="small" v-print="'#printContent'" @click="printedRecord">打印</el-button>
                <el-button size="small" @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
export default {
    name: '',
    components: {},
    props: {
        printIds: {
            type: Array
        },
        printType: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: true,
            listItemWidth: {
                width: '16.6%'
            },
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: '',
            permission: {},

            openTimeConfig: null, // 开单时间配置
            isEditOpenTime: false, // 编辑开单时间

            config: null, // 脚注配置
            isEditConfig: false, // 编辑脚注
            nameConfig: false,
            isPrint: false
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('salesOrder');
        if (this.permission.仓位管理) {
            this.listItemWidth.width = '14.28%';
        } else {
            this.listItemWidth.width = '16.6%';
        }
        this.getConfigByCodes().then(() => {
            this.getSaleOrder();
        });
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyxssj', 'dyxs', 'dyywync'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyxssj':
                                    this.openTimeConfig = data[i];
                                    break;
                                case 'dyxs':
                                    this.config = data[i];
                                    break;
                                case 'dyywync':
                                    this.nameConfig = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        printedRecord() {
            this.$util
                .printedRecord(
                    {
                        OrderId: this.printIds[0],
                        Type: 0
                    },
                    true
                )
                .then(res => {
                    this.isPrint = true;
                });
        },
        //打印并继续开单
        continueToOrder() {
            this.loading = true;
            this.$util
                .printedRecord(
                    {
                        OrderId: this.printIds[0],
                        Type: 0
                    },
                    true
                )
                .then(res => {
                    setTimeout(() => {
                        this.$emit('closePrintDialog', 'continueToOrder');
                    }, 2000);
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        //打印并返回列表
        returnOrderList(delay) {
            if (delay) {
                this.loading = true;
                this.$util
                    .printedRecord(
                        {
                            OrderId: this.printIds[0],
                            Type: 0
                        },
                        true
                    )
                    .then(res => {
                        setTimeout(() => {
                            this.$router.push('/salesManage/salesOrder');
                        }, 2000);
                    })
                    .catch(err => {
                        this.loading = false;
                    });
            } else {
                this.$router.push('/salesManage/salesOrder');
            }
        },
        // 取消
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        // 获取表格
        getSaleOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetOrderForPrintEng',
                    data: {
                        EntpCusOId: this.printIds[0]
                    },
                    hideLoading: true
                })
                .then(res => {
                    let _allNum = 0;
                    let _allPrice = 0;
                    let data = res.data;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allPrice += DetailList[i].Count * DetailList[i].Price;
                    }
                    this.allNum = _allNum;
                    this.allPrice = _allPrice;
                    this.printList.push(res.data);
                    this.company = data.EntpEngName;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        setOpenTime() {
            this.isEditOpenTime = true;
        },
        submitOpenTime() {
            this.isEditOpenTime = false;
        }
    }
};
</script>
<style lang="less" scoped media="print">
.order-detail {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 15px 0;
    color: #000;
}
.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 0px 0px 15px 0px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    margin-left: 2rpx;
}

.print-table-main {
    width: 792px;
    margin-left: 1px;
    font-size: 12px;
    .div-table-cell {
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        // height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        // line-height: 25px;
        padding: 5px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px solid #000;
    }
    .img-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
    }
    .goodimg {
        height: 80px;
        width: 130px;
        margin-top: 10px;
    }
    .cell-content {
        width: 100%;
    }
}
.btn-ctn-left {
    display: flex;
}
</style>
